import * as React from "react";
import DOMPurify from 'dompurify';
import RichTextEditor from 'react-rte';

// DOMPurify strips target= by default; descriptions legitimately use
// target="_blank" links, so re-allow it and enforce a safe rel.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

interface JobDescriptionProps {
  description: string;
}

const JobDescription: React.FC<JobDescriptionProps> = ({ description }) => {
  if (!description) {
    return (
      <div className="content-description">
        <p>Loading job description...</p>
      </div>
    );
  }

  const mode = description.includes('<') ? 'html' : 'markdown';
  const text = RichTextEditor.createValueFromString(description, mode);
  // Demote h1s from user-supplied rich text so the page keeps a single H1
  const html = DOMPurify.sanitize(
    text
      .toString('html')
      .replace(/<h1(\s[^>]*)?>/gi, '<h2$1>')
      .replace(/<\/h1\s*>/gi, '</h2>'),
    { ADD_ATTR: ['target'] }
  );

  return (
    <div className="content-description">
      <p dangerouslySetInnerHTML={{ __html: html }}></p>
    </div>
  );
};

export default JobDescription;
